module.exports = __webpack_public_path__ + "media/images/countrysquared/gm-f7d8f53ed9530e8b823c643f0399574a.svg";